import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BreadcrumbProps {
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ className = '' }) => {
  return (
    <div className={`bg-white/80 backdrop-blur-sm border-b border-navy-100/50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <Link to="/" className="inline-flex items-center text-sm text-teal-600 hover:text-teal-500 font-medium transition-colors">
          <ArrowLeft className="h-4 w-4 mr-1.5" />
          홈으로 돌아가기
        </Link>
      </div>
    </div>
  );
};

export default Breadcrumb;
